import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { TTlsCertificateLevel } from 'types';
import { tlsCertificateLevel } from 'appConstants';
import { useTranslation } from 'react-i18next';

interface IProps {
	setTlsCertificateLevel: (value: Nullable<TTlsCertificateLevel>) => void;
}

const TLSCertificateLevelSelect: React.FC<IProps> = ({ setTlsCertificateLevel }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectSettings') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return tlsCertificateLevel.map((el) => ({
			id: el.id,
			name: tForm(el.name),
		}));
	}, [tForm]);

	return (
		<FormSelect
			testId="TLSCertificateLevelSelect"
			name="tlsCertificateLevel"
			label="settingsLabel"
			options={mappedOptions}
			onChange={setTlsCertificateLevel}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(TLSCertificateLevelSelect);
